export const meta = {
  id: 'A03',
  slug: 'meu-desenvolvimento',
  title: 'Conheça Meu Desenvolvimento',
  description: 'Acompanhe competências, objetivos, metas e sua evolução ao longo do tempo.',
  profile: 'student',
  category: 'desenvolvimento',
  type: 'screen',
  status: 'published',
  order: 80,
  keywords: ['meu desenvolvimento', 'competências', 'metas', 'objetivos', 'progresso', 'evolução'],
  previous: 'A02.1',
  next: 'A04',
  related: ['A02.1', 'A04', 'A13'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Conheça Meu Desenvolvimento

**Meu Desenvolvimento** responde à pergunta: **“Como estou evoluindo?”**. Essa área reúne referências que ajudam você a acompanhar seu desenvolvimento para além de uma tarefa isolada.

## O que você pode acompanhar

Conforme sua experiência estiver configurada, você poderá encontrar competências, níveis ou resultados, objetivos, metas, progresso e outros registros de acompanhamento disponíveis para você.

<HelpImage alt="Visão geral de Meu Desenvolvimento" pendingId="A03.1" />

## Como utilizar

Use essa área para revisar suas prioridades, perceber mudanças ao longo do tempo e conectar o que está aprendendo com as metas que precisa alcançar.

<Callout type="concept">
  **Meu Desenvolvimento** mostra como você está evoluindo. **Meu Plano** organiza o que você fará para avançar.
</Callout>
